"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var ViewWindow_vue_1 = __importDefault(require("./ViewWindow.vue"));
var PermissionsGroup_vue_1 = __importDefault(require("./TheRoles/PermissionsGroup.vue"));
var VAlert_vue_1 = __importDefault(require("./scraps/VAlert.vue"));
var EditRole_vue_1 = __importDefault(require("./TheRoles/EditRole.vue"));
var TopMenu_vue_1 = __importDefault(require("./TheRoles/TopMenu.vue"));
var vue_class_component_1 = __importStar(require("vue-class-component"));
var RolesMixin_1 = __importDefault(require("../mixins/request/RolesMixin"));
var PermissionsMixin_1 = __importDefault(require("../mixins/request/PermissionsMixin"));
var event_bus_1 = require("../event-bus");
var request_1 = __importDefault(require("../request"));
var EchoMixin_1 = __importDefault(require("../mixins/request/EchoMixin"));
var vue_property_decorator_1 = require("vue-property-decorator");
var TheRoles = /** @class */ (function (_super) {
    __extends(TheRoles, _super);
    function TheRoles() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = "the-roles";
        _this.currentRole = {};
        _this.rolePermissions = [];
        return _this;
    }
    TheRoles.prototype.onCurrentRoleChanged = function (role, oldRole) {
        if (oldRole.id) {
            this.echo.leave(this.echoChannels.role + "." + oldRole.id);
        }
        if (role.id) {
            this.echo.channel(this.echoChannels.role + "." + role.id)
                .listen(this.echoEvents.role.permission.update, this.updateRolePermissions);
        }
    };
    TheRoles.prototype.onRolesChanged = function (roles) {
        var _this = this;
        var foundRole = roles.array.find(function (role) { return role.id === _this.currentRole.id; });
        if (foundRole === undefined) {
            this.currentRole = {};
            this.rolePermissions = [];
            return;
        }
        if (foundRole.name !== this.currentRole.name) {
            this.currentRole = foundRole;
        }
    };
    TheRoles.prototype.created = function () {
        event_bus_1.EventBus.$on(event_bus_1.events.role.select, this.onRoleSelectEvent)
            .$on(event_bus_1.events.role.permission.update, this.onRolePermissionUpdateEvent);
        this.echo.channel(this.echoChannels.role)
            .listen(this.echoEvents.role.permission.update, this.updateRolePermissions);
        this.requestRoles();
    };
    TheRoles.prototype.beforeDestroy = function () {
        event_bus_1.EventBus.$off(event_bus_1.events.role.select, this.onRoleSelectEvent)
            .$off(event_bus_1.events.role.permission.update, this.updateRolePermissions);
        this.echo.leave(this.echoChannels.role + "." + this.currentRole.id);
    };
    TheRoles.prototype.onRoleSelectEvent = function (role) {
        var _this = this;
        request_1.default.role.permissions(role.id, this.updateRolePermissions).then(function () {
            _this.currentRole = role;
        });
    };
    TheRoles.prototype.updateRolePermissions = function (permissions) {
        this.rolePermissions = permissions;
    };
    TheRoles.prototype.onRolePermissionUpdateEvent = function (role) {
        return request_1.default.role.permission.update(role.id, { permission: role.permission, assign: role.assign }, this.updateRole);
    };
    __decorate([
        vue_property_decorator_1.Watch("currentRole")
    ], TheRoles.prototype, "onCurrentRoleChanged", null);
    __decorate([
        vue_property_decorator_1.Watch("roles")
    ], TheRoles.prototype, "onRolesChanged", null);
    TheRoles = __decorate([
        vue_class_component_1.default({ components: {
                EditRole: EditRole_vue_1.default,
                PermissionsGroup: PermissionsGroup_vue_1.default,
                TopMenu: TopMenu_vue_1.default,
                VAlert: VAlert_vue_1.default,
                ViewWindow: ViewWindow_vue_1.default
            } })
    ], TheRoles);
    return TheRoles;
}(vue_class_component_1.mixins(RolesMixin_1.default, PermissionsMixin_1.default, EchoMixin_1.default)));
exports.default = TheRoles;
